module.exports = __webpack_public_path__ + "static/img/mdrive_logo.02366e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mdrive_logo.png
// module id = GXZn
// module chunks = 1